import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'

export function SalesRoutes() {
  const OrderWrapper = lazy(() => import('../pages/Sales/Orders/OrderWrapper'))
  const OrderDetailWrapper = lazy(() => import('../pages/order/detail/OrderDetailWrapper'))
  const AgentWrapper = lazy(() => import('../pages/agent/AgentWrapper'))
  const AgentDetailWrapper = lazy(() => import('../pages/agent-detail/AgentDetailWrapper'))
  const AgencyDebtWrapper = lazy(() => import('../pages/debt/agency/AgencyDebtWrapper'))
  const ProductsWrapper = lazy(() => import('../pages/products/ProductsWrapper'))

  const normalRoutes = [
    { path: '/my-orders', component: OrderWrapper },
    { path: '/my-orders/detail/:id?', component: OrderDetailWrapper },
    { path: '/agents', component: AgentWrapper },
    { path: '/agents/detail/:id?', component: AgentDetailWrapper },
    { path: '/debt/agency', component: AgencyDebtWrapper},
    { path: '/my-products', component: ProductsWrapper },
  ];
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {normalRoutes.map((route) => (
          <Route exact key={route.path} path={route.path} component={route.component} />
        ))}
        <Redirect from='/' to='/cashier-pos' />
      </Switch>
    </Suspense>
  );
}
